var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"divCenter",on:{"click":_vm.to_api}})])
}
var staticRenderFns = []

export { render, staticRenderFns }